import {Utils} from 'hasta-la-vista-ui-core'
import {AuthService} from 'hasta-la-vista-middleware-api/service'

export default {

    data(){
        return {
            loading: true,
            valid: false,
            complete: false,
            error: null,
            validateUser: null
        }
    },

    created() {
        Promise.resolve(AuthService.isGuestUser()).then((guest)=>{
            if (guest) {
                this.$router.push("/user/login?redirect=/user/confirm-email-change/" + this.$route.params.changeCode);
            } else {
                Promise.resolve(AuthService.validateChangeEmail(this.$route.params.changeCode)).then(
                    (result) => {
                        // console.log("Confirm Email Change", result);

                        if(result.success) {
                            this.complete = true
                            if(result.data.ResultCode === 0) {
                                this.valid = true
                            } else {
                                this.valid = false

                                this.error = "The email address could not be changed, the email address might already by in use. Please try using another email address."
                            }
                            this.loading = false

                            // console.log("loading", this.loading)
                            // console.log("complete", this.complete)
                            // console.log("valid", this.valid)
                        }
                    },
                    (error) => {
                        Promise.reject(error)
                    }
                );
            }
        })
        
    },
}


// WEBPACK FOOTER //
// ./src/components/pages/confirm-email-change/confirm-email-change.js